import ui from '@kk/ui/locales/da/ui.json';
import calculation from '#/locales/da/calculation.json';
import caseSigning from '#/locales/da/case-signing.json';
import common from '#/locales/da/common.json';
import contractLoan from '#/locales/da/contract-loan.json';
import customer from '#/locales/da/customer.json';
import data from '#/locales/da/data.json';
import enums from '#/locales/da/enums.json';

export const defaultNS = 'common';

export const resources = {
  da: {
    calculation,
    'case-signing': caseSigning,
    common,
    'contract-loan': contractLoan,
    customer,
    data,
    enums,
    ui,
  },
} as const;
